<template>
  <div>
    <v-btn variant="text" :loading="loading" @click="passwordResetClick">Passwort vergessen?</v-btn>
    <v-dialog v-model="showDialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row class="pt-2">
              Eine Mail mit einem Bestätigungscode wurde an das registrierte Mailkonto verschickt. Bitte tragen Sie den Bestätigungscode und ihr neues Passwort in die folgenden Felder ein. Das neue Passwort muss mindestens einen Kleinbuchstaben, einen Großbuchstaben, eine Zahl und 6 Stellen beinhalten.
            </v-row>
            <v-row>
              <v-text-field
                name="token"
                label="Bestätigungscode"
                v-model="token"
                hide-details="auto"
              />
            </v-row>
            <v-row>
              <v-text-field 
                :type="showPassword ? 'text' : 'password'" 
                name="new_password"
                label="neues Passwort" 
                v-model="password"
                hide-details="auto"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :error-messages="passwordErrorMessage"
              />
            </v-row>
            <v-row>
              <v-text-field 
                :type="showPasswordRepeat ? 'text' : 'password'" 
                name="repeat__password"
                label="Passwort wiederholen" 
                v-model="passwordRepeat"
                :append-icon="showPasswordRepeat ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPasswordRepeat = !showPasswordRepeat"
                :error-messages="passwordRepeatErrorMessage"
              />
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="blue darken-1" variant="text" @click="showDialog = false">Schließen</v-btn>
          <v-btn color="blue darken-1" variant="text" @click="confirm" :disabled="disableConfirm">Absenden</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import requestService from "@/store/backendRequests"

export default {
  data() {
    return {
      showDialog: false,
      showPasswordRepeat: false,
      showPassword: false,
      loading: false,
      password: "",
      passwordRepeat: "",
      token: "",
      passwordErrorMessage: undefined,
      passwordRepeatErrorMessage: undefined
    }
  },
  methods: {
    comparePasswordAndPasswordRepeat() {
      this.passwordRepeatErrorMessage = this.password === this.passwordRepeat ? undefined : "Die Eingabe stimmt nicht mit dem Passwort überein.";
    },
    async confirm() {
      await requestService
        .resetPassword(this.password, this.token)
        .then(
          () => {
            this.$store.dispatch('displaySnackbarMessage', 'Das Passwort wurde erfolgreich geändert');
            this.showDialog = false
          },
          (error) => {
            this.$store.dispatch('handleError', error);
          }
        );
    },
    validatePassword() {
      requestService
        .validatePassword(this.password)
        .then(
          (response) => {
            if (response.data == true) {
              this.passwordErrorMessage = undefined;
            } else {
              this.passwordErrorMessage = "Das Passwort entspricht nicht den Richtlinien.";
            }
          },
          (error) => {
            this.$store.dispatch('handleError', error);
          }
        );
    },
    async passwordResetClick() {
      this.loading = true;
      await requestService
        .generatePasswordResetToken()
        .then(
          () => {
            this.showDialog = true
          },
          (error) => {
            this.$store.dispatch('handleError', error);
          }
        );
      this.loading = false;
    }
  },
  computed: {
      disableConfirm: function() {
        if (this.passwordRepeatErrorMessage || this.passwordErrorMessage || this.token == "" || this.password == "" || this.passwordRepeat == "") {
          return true;
        }

        return false;
      }
  },
  watch: {
    password: function() {
      if (!this.password) return;

      this.validatePassword();
      this.comparePasswordAndPasswordRepeat();
    },
    passwordRepeat: function() {
      if (!this.passwordRepeat) return;

      this.comparePasswordAndPasswordRepeat();
    },
  }
}
</script>

<style scoped>
  .v-btn {
    text-transform: none;
  }
</style>